module.exports = __webpack_public_path__ + "static/gem-visa-bg-mobile-978e7cea41ae74760767170311af43bf.jpg";